import AddApplicationBoxLabel from "./add-application-box-label";
import ApplicationRow from "./application-row";

export default { AddApplicationBoxLabel, ApplicationRow };
